import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
/**
 * @name Atom One
 * Atom One dark syntax theme
 *
 * https://github.com/atom/one-dark-syntax
 */
import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';
export var atomoneInit = function atomoneInit(options) {
  var _ref = options || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? [] : _ref$styles;
  return createTheme({
    theme: theme,
    settings: _extends({
      background: '#272C35',
      foreground: '#9d9b97',
      caret: '#797977',
      selection: '#ffffff30',
      selectionMatch: '#2B323D',
      gutterBackground: '#272C35',
      gutterForeground: '#465063',
      gutterBorder: 'transparent',
      lineHighlight: '#2B323D'
    }, settings),
    styles: [{
      tag: [t.function(t.variableName), t.function(t.propertyName), t.url, t.processingInstruction],
      color: 'hsl(207, 82%, 66%)'
    }, {
      tag: [t.tagName, t.heading],
      color: '#e06c75'
    }, {
      tag: t.comment,
      color: '#54636D'
    }, {
      tag: [t.propertyName],
      color: 'hsl(220, 14%, 71%)'
    }, {
      tag: [t.attributeName, t.number],
      color: 'hsl( 29, 54%, 61%)'
    }, {
      tag: t.className,
      color: 'hsl( 39, 67%, 69%)'
    }, {
      tag: t.keyword,
      color: 'hsl(286, 60%, 67%)'
    }, {
      tag: [t.string, t.regexp, t.special(t.propertyName)],
      color: '#98c379'
    }].concat(_toConsumableArray(styles))
  });
};
export var atomone = atomoneInit();